import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from './breakpoints';

const selectors = {
  mainCarousel: '[data-splide-carousel]',
  currentNumber: '[data-splide-current-number]',
};

const updatePageNumber = slider => {
  function mount() {
    update(slider.index);
    slider.on('move', newIndex => {
      update(newIndex);
    });
  }

  function update(newIndex) {
    const currentNumber = slider.root.querySelector(selectors.currentNumber);

    if (currentNumber) {
      const newCount = newIndex + 1;
      const displayNumber = newIndex < 10 ? `0${newCount}` : String(newCount);
      currentNumber.innerHTML = displayNumber;
    }
  }

  return {
    mount,
  };
};

const hideArrows = slider => {
  console.log(slider);
  slider.on('overflow', isOverflow => {
    slider.options = {
      arrows: isOverflow,
      drag: isOverflow,
    };
  });

  if (slider.length <= slider.options.perPage) {
    slider.options = {
      arrows: false,
    };
  }

  slider.on('hidden', () => {
    if (slider.length > slider.options.perPage) {
      slider.options = {
        arrows: true,
      };
    }
  });

  slider.on('visible', () => {
    if (slider.length <= slider.options.perPage) {
      slider.options = {
        arrows: false,
      };
    }
  });
};

const initCarousel = (el, options = {}) => {
  const carousel = el.querySelector(selectors.mainCarousel);

  if (carousel) {
    const carouselOptions = {
      perPage: 2,
      perMove: 1,
      gap: '1rem',
      mediaQuery: 'min',
      pagination: false,
      breakpoints: {
        [unitlessBreakpoints.md]: {
          perPage: 3,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 4,
        },
      },
      ...options,
    };

    const splide = new Splide(carousel, carouselOptions);
    splide.mount({
      updatePageNumber,
    });

    hideArrows(splide);
  }
};

export { initCarousel, updatePageNumber };
